import { Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import CustomInput from '../../components/customInput/CustomInput';
import MyCustomImageUploader from '../../components/imageInput/MyCustomImageUploader';
import { SettingModel } from '../../config/types/models/SettingModel';
import { useAwsUpload } from '../../dataProviders/useAwsUpload';

type IProps = {
  setting: SettingModel;
  setSetting: (s: SettingModel) => void;
};

function S3Setting({ setting, setSetting }: IProps) {
  const t = useTranslate();
  const { loading, upload } = useAwsUpload();

  return (
    <Paper sx={{ padding: 2, marginTop: 2 }}>
      <Typography variant='subtitle2'>{t('S3Settings')}</Typography>
      <CustomInput
        value={setting?.AWS_ACCESS_KEY_ID || ''}
        onChange={(e) => {
          setSetting({ ...setting, AWS_ACCESS_KEY_ID: e.target.value });
        }}
        label={t('AWS_ACCESS_KEY_ID')}
      />

      <CustomInput
        value={setting?.AWS_SECRET_ACCESS_KEY || ''}
        onChange={(e) => {
          setSetting({ ...setting, AWS_SECRET_ACCESS_KEY: e.target.value });
        }}
        label={t('AWS_SECRET_ACCESS_KEY')}
      />

      <CustomInput
        value={setting?.AWS_REGION || ''}
        onChange={(e) => {
          setSetting({ ...setting, AWS_REGION: e.target.value });
        }}
        label={t('AWS_REGION')}
      />

      <CustomInput
        value={setting?.AWS_S3_BUCKET || ''}
        onChange={(e) => {
          setSetting({ ...setting, AWS_S3_BUCKET: e.target.value });
        }}
        label={t('AWS_S3_BUCKET')}
      />
    </Paper>
  );
}

export default S3Setting;
